import { tns } from "../../_scripts/tiny-slider/src/tiny-slider";

export default config => tns(config);
